export type ProtectedGateState = "loading" | "ready" | "guest" | "app_uninstalled";

export type ProtectedGateResult = "ready" | "guest" | "app_uninstalled";

/**
 * After Stripe Checkout / Portal, CreditsPage strips return query params.
 * That must not send an already-restored session back to Welcome.
 */
export function nextProtectedGateState(
  previous: ProtectedGateState,
  result: ProtectedGateResult,
  hasAccount: boolean,
): ProtectedGateState {
  if (result === "app_uninstalled") {
    return "app_uninstalled";
  }
  if (hasAccount || result === "ready") {
    return "ready";
  }
  if (previous === "ready") {
    return "ready";
  }
  return "guest";
}
